import script from "./UiFormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiFormField.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiFormField.vue?vue&type=style&index=0&id=1a93022f&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__